import React, { useState } from 'react';
import { AI_COLORS, AI_FONTS } from '../shared';

const cenarios = [
  {
    titulo: 'Cenário 1 — Gengiva sangrando',
    contexto:
      'Dona Maria, 68 anos, percebeu que sua gengiva sangra durante a escovação há alguns dias. Ela acha que isso acontece porque está escovando bem e decide parar de escovar a região que sangra.',
    pergunta: 'O que Dona Maria deveria fazer?',
    opcoes: [
      { texto: 'Parar de escovar a região que sangra', correto: false, feedback: 'Sangramento na gengiva não é considerado normal e pode indicar inflamação (gengivite). Parar de escovar piora a situação.' },
      { texto: 'Continuar a higiene normalmente e procurar orientação profissional', correto: true, feedback: 'Correto! Sangramento na gengiva não é normal. Dona Maria deve manter a higiene e consultar um cirurgião dentista.' },
      { texto: 'Esperar alguns meses para ver se melhora sozinho', correto: false, feedback: 'Aguardar sem tratamento pode piorar a gengivite e evoluir para periodontite.' },
    ],
  },
  {
    titulo: 'Cenário 2 — Boca seca',
    contexto:
      'Seu João, 72 anos, usa alguns medicamentos e começou a sentir a boca muito seca durante o dia. Também percebe dificuldade para mastigar alguns alimentos.',
    pergunta: 'O que pode ajudar inicialmente?',
    opcoes: [
      { texto: 'Beber água ao longo do dia', correto: true, feedback: 'Correto! A hidratação ajuda a aliviar a sensação de boca seca (xerostomia). Seu João também deve comunicar o problema ao médico e dentista.' },
      { texto: 'Parar de escovar os dentes', correto: false, feedback: 'Incorreto. Boca seca já aumenta o risco de cáries — parar de escovar agravaria o problema.' },
      { texto: 'Comer mais doces', correto: false, feedback: 'Incorreto. O consumo de doces aumenta o risco de cáries, especialmente com boca seca.' },
    ],
  },
  {
    titulo: 'Cenário 3 — Ferida na boca',
    contexto:
      'Seu Carlos percebeu uma ferida na boca que está presente há algumas semanas e ainda não melhorou. Ele não sente muita dor e resolveu ignorar a situação.',
    pergunta: 'O que seria mais adequado?',
    opcoes: [
      { texto: 'Esperar mais algumas semanas para ver se melhora', correto: false, feedback: 'Feridas que não cicatrizam merecem atenção urgente — podem ser sinal de câncer bucal.' },
      { texto: 'Procurar avaliação profissional', correto: true, feedback: 'Correto! Qualquer ferida na boca que dure mais de 15 dias deve ser avaliada por um cirurgião dentista. O diagnóstico precoce pode salvar vidas.' },
      { texto: 'Escovar mais forte a região', correto: false, feedback: 'Incorreto. Escovar com força pode piorar a ferida e causar mais danos.' },
    ],
  },
  {
    titulo: 'Cenário 4 — Diabetes e saúde bucal',
    contexto:
      'Dona Helena possui diabetes e percebeu sangramento na gengiva durante a escovação. Ela acredita que não existe relação entre diabetes e saúde bucal.',
    pergunta: 'Qual opção está correta?',
    opcoes: [
      { texto: 'Diabetes e saúde bucal podem estar relacionadas — ela deve procurar um cirurgião dentista', correto: true, feedback: 'Correto! Problemas bucais e diabetes podem influenciar um ao outro. Tratar a saúde bucal ajuda no controle da glicemia.' },
      { texto: 'Diabetes afeta apenas o corpo, não a boca', correto: false, feedback: 'Incorreto. O diabetes pode aumentar o risco de infecções e dificultar a cicatrização na boca.' },
      { texto: 'Escovar os dentes não faz diferença para quem tem diabetes', correto: false, feedback: 'Incorreto. A higiene bucal é ainda mais importante para quem tem diabetes.' },
    ],
  },
  {
    titulo: 'Cenário 5 — Escovação com muita força',
    contexto:
      'Seu Pedro acredita que quanto mais força usar ao escovar os dentes, mais limpos eles ficarão.',
    pergunta: 'O que seria melhor?',
    opcoes: [
      { texto: 'Escovar com força, utilizando escova dura', correto: false, feedback: 'Escovar com força e escova dura pode desgastar o esmalte e machucar a gengiva, causando Lesão Cervical Não Cariosa (LCNC).' },
      { texto: 'Escovar suavemente com escova macia', correto: true, feedback: 'Correto! Movimentos suaves com escova macia são mais eficazes e não machucam os dentes e gengiva.' },
      { texto: 'Escovar apenas uma vez ao dia com força', correto: false, feedback: 'Incorreto. Além de machucador, escovar só uma vez não é suficiente.' },
    ],
  },
  {
    titulo: 'Cenário 6 — Estresse e apertamento dos dentes',
    contexto:
      'Dona Lúcia anda preocupada e percebe que acorda frequentemente com dor na região do rosto e sensação de cansaço nos dentes.',
    pergunta: 'O que pode estar acontecendo?',
    opcoes: [
      { texto: 'O estresse pode estar relacionado ao apertamento dos dentes (bruxismo)', correto: true, feedback: 'Correto! O estresse pode causar bruxismo (apertamento ou ranger dos dentes), levando a dores e desgaste dental.' },
      { texto: 'Os dentes estão crescendo novamente', correto: false, feedback: 'Incorreto. Dentes adultos não crescem novamente.' },
      { texto: 'Não possui relação com a saúde bucal', correto: false, feedback: 'Incorreto. O bruxismo é um problema bucal diretamente relacionado ao estresse.' },
    ],
  },
  {
    titulo: 'Cenário 7 — Alimentação',
    contexto:
      'Seu Antônio costuma consumir refrigerantes e doces várias vezes ao dia e raramente bebe água.',
    pergunta: 'Qual hábito poderia ajudar?',
    opcoes: [
      { texto: 'Aumentar consumo de água e melhorar a alimentação', correto: true, feedback: 'Correto! Hábitos saudáveis, hidratação e redução do açúcar ajudam a proteger a saúde geral e bucal.' },
      { texto: 'Escovar os dentes apenas à noite', correto: false, feedback: 'Incorreto. Escovar apenas à noite não compensa o consumo excessivo de açúcar ao longo do dia.' },
      { texto: 'Comer ainda mais doces para acostumar os dentes', correto: false, feedback: 'Incorreto. Mais açúcar significa mais risco de cáries.' },
    ],
  },
  {
    titulo: 'Cenário 8 — Saúde bucal e envelhecimento',
    contexto:
      'Seu José acredita que perder dentes é algo esperado com a idade e que não há muito o que fazer para evitar.',
    pergunta: 'Essa informação está correta?',
    opcoes: [
      { texto: 'Sim, é inevitável com a idade', correto: false, feedback: 'Incorreto. A perda dentária não é inevitável — com higiene adequada e visitas regulares ao dentista, é possível manter os dentes por toda a vida.' },
      { texto: 'Não, com cuidados adequados é possível manter os dentes', correto: true, feedback: 'Correto! O envelhecimento não significa perder dentes. Cuidados diários e acompanhamento profissional fazem toda a diferença.' },
    ],
  },
  {
    titulo: 'Cenário 9 — Mau hálito',
    contexto:
      'Dona Célia percebeu que está com mau hálito frequentemente. Ela acredita que isso acontece apenas por problemas no estômago e não mudou seus hábitos de higiene bucal.',
    pergunta: 'O que seria mais adequado?',
    opcoes: [
      { texto: 'Ignorar a higiene bucal — é problema de estômago', correto: false, feedback: 'Incorreto. O mau hálito pode estar relacionado a diferentes fatores, incluindo a higiene bucal inadequada.' },
      { texto: 'Manter boa higiene bucal e procurar orientação se o problema continuar', correto: true, feedback: 'Correto! A higiene bucal adequada é um dos principais fatores no controle do mau hálito.' },
      { texto: 'Escovar os dentes apenas quando sair de casa', correto: false, feedback: 'Incorreto. A higiene precisa ser diária, pelo menos 3 vezes ao dia.' },
    ],
  },
  {
    titulo: 'Cenário 10 — Sensibilidade nos dentes',
    contexto:
      'Dona Marta começou a sentir sensibilidade ao tomar água gelada e percebeu uma pequena região desgastada próxima à gengiva.',
    pergunta: 'O que ela deve fazer?',
    opcoes: [
      { texto: 'Ignorar porque vai desaparecer sozinho', correto: false, feedback: 'Incorreto. Desgaste próximo à gengiva (Lesão Cervical Não Cariosa) não melhora sozinho e pode piorar sem tratamento.' },
      { texto: 'Procurar orientação profissional e evitar escovar com muita força', correto: true, feedback: 'Correto! A sensibilidade e o desgaste precisam de avaliação profissional. Escovar com menos força previne o agravamento.' },
      { texto: 'Escovar a região com mais força para limpar melhor', correto: false, feedback: 'Incorreto. Escovar com mais força piora o desgaste e a sensibilidade.' },
    ],
  },
  {
    titulo: 'Cenário 11 — Falta de higiene antes de dormir',
    contexto:
      'Seu Antônio costuma escovar os dentes durante o dia, mas quase sempre dorme sem fazer a higiene bucal porque sente muito sono à noite.',
    pergunta: 'Qual seria a melhor orientação?',
    opcoes: [
      { texto: 'Dormir sem escovar não faz diferença se escovou de dia', correto: false, feedback: 'Incorreto. Durante o sono, a produção de saliva diminui, deixando os dentes mais vulneráveis.' },
      { texto: 'Realizar a higiene bucal antes de dormir', correto: true, feedback: 'Correto! A higiene antes de dormir ajuda a reduzir o acúmulo de resíduos e bactérias durante a noite.' },
      { texto: 'Escovar somente pela manhã', correto: false, feedback: 'Incorreto. É necessário escovar pelo menos 3 vezes ao dia, incluindo antes de dormir.' },
    ],
  },
];

export default function CenariosSimulacao() {
  const [cenarioAtual, setCenarioAtual] = useState(0);
  const [selecionado, setSelecionado] = useState(null);
  const [concluido, setConcluido] = useState(false);
  const [acertos, setAcertos] = useState(0);

  const cenario = cenarios[cenarioAtual];

  const handleEscolha = (index) => {
    if (selecionado !== null) return;
    setSelecionado(index);
    if (cenario.opcoes[index].correto) setAcertos((a) => a + 1);
  };

  const proximo = () => {
    if (cenarioAtual + 1 < cenarios.length) {
      setCenarioAtual((c) => c + 1);
      setSelecionado(null);
    } else {
      setConcluido(true);
    }
  };

  const reiniciar = () => {
    setCenarioAtual(0);
    setSelecionado(null);
    setConcluido(false);
    setAcertos(0);
  };

  if (concluido) {
    const pct = Math.round((acertos / cenarios.length) * 100);
    return (
      <div style={styles.wrap}>
        <div style={styles.card}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '3rem', marginBottom: 8 }}>🎉</div>
            <h2 style={{ fontFamily: AI_FONTS.title, color: AI_COLORS.blue900, fontSize: '1.8rem', margin: '0 0 8px' }}>
              Parabéns!
            </h2>
            <p style={{ color: AI_COLORS.textMuted, marginBottom: 12 }}>
              Você completou todos os cenários.
            </p>
            <div style={{ fontSize: '3rem', fontWeight: 'bold', color: AI_COLORS.blue400, margin: '16px 0' }}>
              {acertos}/{cenarios.length}
            </div>
            <p style={{ lineHeight: 1.7, marginBottom: 24, color: AI_COLORS.textDark }}>
              {pct >= 80
                ? '🏆 Excelente! Você soube lidar bem com as situações do cotidiano.'
                : pct >= 60
                ? '👍 Bom resultado! Revise os cenários e aprenda com as explicações.'
                : '📚 Os cenários mostram situações reais. Explore o website para aprender mais!'}
            </p>
            <p style={{ fontSize: '0.92rem', color: AI_COLORS.textMuted, marginBottom: 24, lineHeight: 1.65 }}>
              Lembre-se: sempre consulte profissionais de saúde para decisões sobre a sua saúde bucal.
            </p>
            <button style={styles.btn} onClick={reiniciar}>
              Recomeçar
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.wrap}>
      <style>{`
        @keyframes reacaoFeliz {
          0%   { transform: scale(0) rotate(-12deg); opacity: 0; }
          60%  { transform: scale(1.25) rotate(8deg); opacity: 1; }
          80%  { transform: scale(0.95) rotate(-4deg); }
          100% { transform: scale(1) rotate(0deg); }
        }
        @keyframes reacaoTriste {
          0%   { transform: scale(0) translateY(-8px); opacity: 0; }
          50%  { transform: scale(1.1) translateY(0); opacity: 1; }
          65%  { transform: translateX(-6px); }
          80%  { transform: translateX(6px); }
          100% { transform: translateX(0) scale(1); }
        }
      `}</style>
      <div style={{ maxWidth: 680, width: '100%' }}>
        <h2 style={{ fontFamily: AI_FONTS.title, color: AI_COLORS.blue900, textAlign: 'center', marginBottom: 4 }}>
          Cenários de Simulação
        </h2>
        <p style={{ color: AI_COLORS.textMuted, textAlign: 'center', marginBottom: 20 }}>
          Cenário {cenarioAtual + 1} de {cenarios.length}
        </p>

        <div style={styles.progress}>
          <div style={{ ...styles.progressBar, width: `${(cenarioAtual / cenarios.length) * 100}%` }} />
        </div>

        <div style={{ ...styles.card, marginTop: 16 }}>
          <h3 style={{ fontFamily: AI_FONTS.title, color: AI_COLORS.blue900, marginTop: 0, fontSize: '1.2rem' }}>
            {cenario.titulo}
          </h3>

          <div style={{ background: AI_COLORS.bgBlue50, borderRadius: 10, padding: '14px 18px', marginBottom: 20, lineHeight: 1.7 }}>
            {cenario.contexto}
          </div>

          <p style={{ fontWeight: 700, marginBottom: 14, color: AI_COLORS.textDark }}>
            {cenario.pergunta}
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {cenario.opcoes.map((op, i) => {
              let bg = AI_COLORS.bgBlue50;
              let border = 'transparent';
              if (selecionado !== null) {
                if (op.correto) { bg = AI_COLORS.green50; border = '#4CAF50'; }
                else if (i === selecionado) { bg = '#FCE4EC'; border = '#EF9A9A'; }
              }
              return (
                <button
                  key={i}
                  style={{
                    ...styles.option,
                    backgroundColor: bg,
                    border: `2px solid ${border}`,
                    cursor: selecionado !== null ? 'default' : 'pointer',
                  }}
                  onClick={() => handleEscolha(i)}
                >
                  {op.texto}
                </button>
              );
            })}
          </div>

          {selecionado !== null && (
            <div
              key={`reacao-${cenarioAtual}-${selecionado}`}
              style={{
                marginTop: 18,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 6,
              }}
            >
              <div
                role="img"
                aria-label={cenario.opcoes[selecionado].correto ? 'Resposta correta' : 'Resposta incorreta'}
                style={{
                  fontSize: '3.4rem',
                  lineHeight: 1,
                  animation: cenario.opcoes[selecionado].correto
                    ? 'reacaoFeliz 0.6s ease'
                    : 'reacaoTriste 0.6s ease',
                }}
              >
                {cenario.opcoes[selecionado].correto ? '😄' : '😟'}
              </div>
              <span
                style={{
                  fontWeight: 700,
                  fontSize: '0.95rem',
                  color: cenario.opcoes[selecionado].correto ? '#2E7D32' : '#C62828',
                }}
              >
                {cenario.opcoes[selecionado].correto ? 'Muito bem!' : 'Quase lá!'}
              </span>
            </div>
          )}

          {selecionado !== null && (
            <div style={{
              marginTop: 16,
              background: cenario.opcoes[selecionado].correto ? AI_COLORS.green50 : '#FCE4EC',
              borderLeft: `4px solid ${cenario.opcoes[selecionado].correto ? '#4CAF50' : '#EF9A9A'}`,
              borderRadius: 8,
              padding: '12px 16px',
              lineHeight: 1.65,
            }}>
              <strong>{cenario.opcoes[selecionado].correto ? '✅ ' : '❌ '}</strong>
              {cenario.opcoes[selecionado].feedback}
            </div>
          )}

          {selecionado !== null && (
            <div style={{ marginTop: 20, textAlign: 'right' }}>
              <button style={styles.btn} onClick={proximo}>
                {cenarioAtual + 1 < cenarios.length ? 'Próximo cenário →' : 'Ver resultado'}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #E3F2FD 0%, #B3E5FC 55%, #EDE7F6 100%)',
    padding: '80px 24px 120px',
    fontFamily: AI_FONTS.body,
  },
  card: {
    background: 'white',
    borderRadius: 16,
    padding: '28px 26px',
    maxWidth: 680,
    width: '100%',
    boxShadow: '0 6px 24px rgba(1,87,155,0.12)',
  },
  option: {
    padding: '12px 16px',
    borderRadius: 10,
    textAlign: 'left',
    fontSize: '0.93rem',
    transition: 'background-color 0.2s',
    fontFamily: AI_FONTS.body,
    lineHeight: 1.5,
    color: AI_COLORS.textDark,
  },
  btn: {
    padding: '11px 28px',
    background: AI_COLORS.blue800,
    color: 'white',
    border: 'none',
    borderRadius: 10,
    fontSize: '0.95rem',
    cursor: 'pointer',
    fontWeight: 700,
    fontFamily: AI_FONTS.body,
  },
  progress: {
    width: '100%',
    height: 8,
    background: '#e0e0e0',
    borderRadius: 4,
    overflow: 'hidden',
  },
  progressBar: {
    height: '100%',
    background: AI_COLORS.blue400,
    transition: 'width 0.4s ease',
  },
};
